/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Bulk_PlanInputs */

const en_portal_goal_bulk_plan = /** @type {(inputs: Portal_Goal_Bulk_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 strength days, more weight every week`)
};

const pl_portal_goal_bulk_plan = /** @type {(inputs: Portal_Goal_Bulk_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 dni siłowe, więcej ciężaru co tydzień`)
};

/**
* | output |
* | --- |
* | "4 strength days, more weight every week" |
*
* @param {Portal_Goal_Bulk_PlanInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_bulk_plan = /** @type {((inputs?: Portal_Goal_Bulk_PlanInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Bulk_PlanInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_bulk_plan(inputs)
	return en_portal_goal_bulk_plan(inputs)
});